import React, { useEffect, useState } from 'react';
import { PedidosService } from '../services/pedidosService';
import { ChoferesService } from '../services/choferesService';
import FormularioPedido from './FormularioPedido';
import TablaPedidos from './TablaPedidos';
import './TablaPedidos.css';
import './DashboardCajas.css';

const DashboardCajas = ({ onLogout }) => {

  const [pedidos, setPedidos] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [pedidoEditar, setPedidoEditar] = useState(null);

  const [usuarioData] = useState(() =>
    JSON.parse(localStorage.getItem('usuario'))
  );

  // 🔍 FILTROS
  const [busquedaFolio, setBusquedaFolio] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroFecha, setFiltroFecha] = useState('');

  useEffect(() => {
    const unsubscribePedidos = PedidosService.suscribirsePedidos((pedidosRecibidos) => {
      console.log('DashboardCajas: Pedidos recibidos:', pedidosRecibidos.length, pedidosRecibidos);
      setPedidos(pedidosRecibidos);
    });
    const unsubscribeChoferes = ChoferesService.suscribirseChoferes(setChoferes);

    return () => {
      unsubscribePedidos();
      unsubscribeChoferes();
    };
  }, []);

  const handleCrearPedido = async (datosPedido) => {
    try {
      await PedidosService.crearPedido(datosPedido);
      setMostrarFormulario(false);
      setPedidoEditar(null);
    } catch (error) {
      console.error('Error al crear pedido:', error);
      alert('No se pudo registrar el pedido.');
    }
  };

  const handleEditarPedido = async (datosPedido) => {
    try {
      if (!pedidoEditar || !pedidoEditar.id) {
        alert('Error: No se puede identificar el pedido a editar.');
        return;
      }
      
      await PedidosService.actualizarPedido(pedidoEditar.id, datosPedido);
      setMostrarFormulario(false);
      setPedidoEditar(null);
      alert('Pedido actualizado correctamente.');
    } catch (error) {
      console.error('Error al actualizar pedido:', error);
      alert('No se pudo actualizar el pedido.');
    }
  };

  const handleVerDetalles = (pedido) => {
    setPedidoEditar(pedido);
    setMostrarFormulario(true);
  };

  const handleCancelarFormulario = () => {
    setMostrarFormulario(false);
    setPedidoEditar(null);
  };

  // 🧠 FILTRADO + ORDENAMIENTO
  const pedidosFiltrados = pedidos
    .filter(pedido => {
      const coincideFolio = pedido.numeroDocumento
        ?.toString()
        .toLowerCase()
        .includes(busquedaFolio.toLowerCase());

      const coincideEstado =
        filtroEstado === 'todos' || pedido.estatus === filtroEstado;

      const coincideFecha =
        !filtroFecha || pedido.fechaCompra === filtroFecha;

      return coincideFolio && coincideEstado && coincideFecha;
    })
    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

  // Debug: Log para verificar filtrado
  useEffect(() => {
    console.log('DashboardCajas: Total pedidos:', pedidos.length);
    console.log('DashboardCajas: Pedidos filtrados:', pedidosFiltrados.length);
    console.log('DashboardCajas: Filtros activos:', { busquedaFolio, filtroEstado, filtroFecha });
  }, [pedidos, pedidosFiltrados, busquedaFolio, filtroEstado, filtroFecha]);

  return (
    <div className="dashboard-cajas">
      <header className="header">
        <div className="logo">Gestión de Cajas</div>

        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <button
            className="btn-primary"
            onClick={() => {
              setPedidoEditar(null);
              setMostrarFormulario(true);
            }}
          >
            Registrar Pedido
          </button>

          <button
            className="btn-secondary"
            onClick={() => {
              localStorage.clear();
              window.location.href = '/';
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </header>

      <main className="main-content">
        <section className="gestion-pedidos">

          <div className="section-header">
            <h2>Últimos Pedidos Registrados</h2>
          </div>

          {/* 🔍 FILTROS */}
          <div className="filtros">
            <input
              type="text"
              className="filtro-input"
              placeholder="Buscar por folio"
              value={busquedaFolio}
              onChange={(e) => setBusquedaFolio(e.target.value)}
            />

            <select
              className="filtro-select"
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              <option value="todos">Todos</option>
              <option value="en_preparacion">En Preparación</option>
              <option value="ruta">En Ruta</option>
              <option value="entregado">Entregado</option>
              <option value="cancelado">Cancelado</option>
            </select>

            <input
              type="date"
              className="filtro-date"
              value={filtroFecha}
              onChange={(e) => setFiltroFecha(e.target.value)}
            />
          </div>

          <TablaPedidos
            pedidos={pedidosFiltrados}
            choferes={choferes}
            onActualizarPedido={() => {}}
            onVerDetalles={handleVerDetalles}
            allowStatusChange={false}
          />
        </section>
      </main>

      {mostrarFormulario && (
        <FormularioPedido
          choferes={choferes}
          onSubmit={pedidoEditar ? handleEditarPedido : handleCrearPedido}
          onCancel={handleCancelarFormulario}
          modo="cajas"
          pedidoEditar={pedidoEditar}
        />
      )}
    </div>
  );
};

export default DashboardCajas;
